import React, { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "./lib/i18n";
import { CartProvider } from "./lib/cart";
import { WishlistProvider } from "./lib/wishlist";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Products from "./components/Products";
import TrustBadges from "./components/TrustBadges";
import CorporateGifting from "./components/CorporateGifting";
import Gallery from "./components/Gallery";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import OrderDialog from "./components/OrderDialog";
import BackgroundMusic from "./components/BackgroundMusic";
import IntroOverlay from "./components/IntroOverlay";
import ScrollReveal from "./components/ScrollReveal";
import Admin from "./components/Admin";
import SiteBackground from "./components/SiteBackground";
import CretanHeritage from "./components/CretanHeritage";
import CartDrawer from "./components/CartDrawer";
import CookieConsent from "./components/CookieConsent";
import AIChat from "./components/AIChat";
import OrderTracking from "./components/OrderTracking";
import { CretanMap, Producers, Testimonials, InstagramTeaser } from "./components/StorySections";
import { Privacy, Terms, Refund, Cookies, Imprint } from "./components/Legal";

const Home = () => {
  const [orderOpen, setOrderOpen] = useState(false);
  const [productType, setProductType] = useState("premium");

  const openOrder = (type = "premium") => {
    setProductType(type);
    setOrderOpen(true);
  };

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div id="top" className="min-h-screen relative">
      <SiteBackground />
      <div className="relative" style={{ zIndex: 1 }}>
        <IntroOverlay />
        <BackgroundMusic />

        <Navbar
          onShop={() => scrollTo("heritage")}
          onOrder={() => scrollTo("heritage")}
        />

        <Hero
          onShop={() => scrollTo("heritage")}
          onCorporate={() => scrollTo("corporate")}
        />

        <ScrollReveal>
          <CretanHeritage />
        </ScrollReveal>

        <TrustBadges />

        <ScrollReveal>
          <Gallery />
        </ScrollReveal>

        <ScrollReveal>
          <CretanMap />
        </ScrollReveal>

        <ScrollReveal>
          <Producers />
        </ScrollReveal>

        <ScrollReveal>
          <CorporateGifting onInquire={() => scrollTo("contact")} />
        </ScrollReveal>

        <ScrollReveal>
          <Testimonials />
        </ScrollReveal>

        <InstagramTeaser />

        <ScrollReveal>
          <About />
        </ScrollReveal>

        <ScrollReveal>
          <Contact />
        </ScrollReveal>

        <Footer />

        <OrderDialog
          open={orderOpen}
          onOpenChange={setOrderOpen}
          productType={productType}
        />

        <CartDrawer />
        <AIChat />
      </div>
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <CartProvider>
        <WishlistProvider>
        <div className="App">
        <Toaster
          theme="dark"
          position="top-center"
          toastOptions={{
            style: {
              background: "#000",
              color: "#f4ead5",
              border: "1px solid rgba(201,169,97,0.4)",
              fontFamily: "Manrope, sans-serif",
            },
          }}
        />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/refund" element={<Refund />} />
            <Route path="/cookies" element={<Cookies />} />
            <Route path="/imprint" element={<Imprint />} />
            <Route path="/track" element={<OrderTracking />} />
          </Routes>
          <CookieConsent />
        </BrowserRouter>
        </div>
        </WishlistProvider>
      </CartProvider>
    </LanguageProvider>
  );
}

export default App;
